import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box, Button, Alert, Typography } from '@mui/material';

interface Props { open: boolean; onClose: () => void; onSubmit: (d: any) => Promise<void>; initialData?: any | null; loading: boolean; error?: string | null; }

export function SaintsForm({ open, onClose, onSubmit, initialData, loading, error }: Props) {
  const [slug, setSlug] = useState('');
  const [title, setTitle] = useState('');
  const [contentText, setContentText] = useState('[]');
  const [jsonError, setJsonError] = useState<string | null>(null);

  useEffect(() => {
    if (initialData) {
      setSlug(initialData.slug || '');
      setTitle(initialData.title || '');
      setContentText(JSON.stringify(initialData.content ?? [], null, 2));
    } else {
      setSlug(''); setTitle('');
      setContentText(JSON.stringify([{ type: 'text', text: '' }], null, 2));
    }
    setJsonError(null);
  }, [initialData, open]);

  const submit = async () => {
    let content: unknown;
    try { content = JSON.parse(contentText); }
    catch { setJsonError('Некорректный JSON'); return; }
    if (!Array.isArray(content)) { setJsonError('Content должен быть JSON-массивом блоков'); return; }
    setJsonError(null);
    await onSubmit({ slug, title, content });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{initialData ? 'Редактировать святого' : 'Добавить святого'}</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField label="Заголовок" fullWidth value={title} onChange={(e) => setTitle(e.target.value)} />
          <TextField label="Слаг (латиница, цифры, дефис)" fullWidth value={slug} onChange={(e) => setSlug(e.target.value)} />
          <Typography variant="caption" color="text.secondary">
            Content — JSON-массив блоков. Текст: {'{ "type": "text", "text": "..." }'}. Фото: {'{ "type": "image", "src": "assets/img/saints/...jpg", "caption": "..." }'}.
          </Typography>
          <TextField label="Content (JSON)" fullWidth multiline minRows={12} value={contentText}
            onChange={(e) => setContentText(e.target.value)} error={!!jsonError} helperText={jsonError || ' '}
            InputProps={{ sx: { fontFamily: 'monospace', fontSize: 13 } }} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button onClick={submit} variant="contained" disabled={loading || !title || !slug}>{loading ? 'Сохранение...' : 'Сохранить'}</Button>
      </DialogActions>
    </Dialog>
  );
}
